import { createColumnHelper } from '@tanstack/react-table';
import { SortableHeadCell } from 'components/tables/cells';
import { MontelAccount } from 'domain/account/interfaces';
import { TextColumnProps } from 'components/tables/columnTypes';
import AccountTrialsCell from './TrialsCell';
import { SubscriptionStatus } from 'domain/subscription/interfaces/Subscription';

const columnHelper = createColumnHelper<MontelAccount>();

export const companyUserColumns = {
	activeTrials: (overrideProps?: TextColumnProps<MontelAccount>) =>
		columnHelper.accessor((row) => `${row.firstName} ${row.lastName}`, {
			id: 'trials',
			enableSorting: true,
			size: 100,
			header: ({ header }) => (
				<SortableHeadCell
					text="Trials"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<AccountTrialsCell accountId={info.row.original.id} iconsOnly />
			),
			...overrideProps?.columnDefProps,
		}),

	inactiveTrials: (overrideProps?: TextColumnProps<MontelAccount>) =>
		columnHelper.accessor((row) => row.email.value, {
			id: 'inactiveTrials',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Inactive trials"
					header={header}
					tooltipText="Trials that are canceled or expired"
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<AccountTrialsCell
					accountId={info.row.original.id}
					statuses={[
						SubscriptionStatus.Canceled,
						SubscriptionStatus.Expired,
					]}
					iconsOnly
					faded
				/>
			),
			...overrideProps?.columnDefProps,
		}),
};
